import { useMutation } from '@tanstack/react-query'
import { useAuth } from '@clerk/clerk-react'

import { requireAuthToken } from '@/lib/api'

import { checkSnippetImpact } from '../api'

/**
 * On demand, not on keystroke: the relay builds one fact catalogue per
 * referencing duty to answer this, so it runs when the author asks.
 */
export function useSnippetImpactMutation() {
  const { getToken } = useAuth()

  return useMutation({
    mutationFn: async ({ id, content }: { id: string; content: string }) =>
      checkSnippetImpact(await requireAuthToken(getToken), id, content),
  })
}
